<template>
  <div>
    <div class="page-top">
      <div class="container px-4 px-lg-5">
        <div class="row gx-4 gx-lg-5 justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="list-main-title mb-5">
              アフィリエイト利用規約
            </h2>
          </div>
        </div>
        <div class="content-text">
          <h3 class="list-title mt-5">
            重要
          </h3>
          <p>
            勝winアフィリエイトプログラムに参加申請していただく前に、アフィリエイトプログラムにおける規約と条件を閲読並びにご理解いただく必要がございます。そして、
            これらの規約はアフィリエイトパートナーまたはアフィリエイトパートナーが代表する組織を拘束する力を有します。
          </p>
          <p>
            万が一規約の如何なる箇所が不明瞭な場合は、当サイトのアフィリエイトチーム({{ affiliateEmail }})までご連絡くださいませ。また、本規約を遵守いただけない場合は、
            アフィリエイトパートナーとして参加いただくことができません。
          </p>
          <p>
            当社(Initial Singularity
            Limited)が、アフィリエイトパートナーが本契約に違反している、または相応しくないと判断した場合、当社は予告なしに本契約を一方的に解除する権利を有します。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            定義と解釈
          </h3>

          <p>
            「当サイト」とは、
            <a
              class="links"
              href="https://www.katsuwin.ai"
              target="_self"
            >Katsuwin.ai</a>
            を意味します。
          </p>
          <p>
            「勝win」とは、
            <a
              class="links"
              href="https://www.katsuwin.ai"
              target="_self"
            >Katsuwin.ai</a>
            を意味します。
          </p>
          <p>「当社」とは、当サイトの運営会社である、 Initial Singularity Limited を意味します。</p>
          <p>
            「アフィリエイトプログラム」は、アフィリエイトパートナーと企業のパートナーシップを意味し、アフィリエイトモデルを使用してマーケティングを行い、新規メンバーを当サイトに誘致することで、コミッションが支払われます。
          </p>
          <p>
            「アフィリエイトパートナー」とは、当サイトに登録および本アフィリエイトプログラムに参加されるメンバーを意味します。
          </p>
          <p>
            「アフィリエイトメンバー」とは、アフィリエイトパートナーが規約に基づいて誘致したプレイヤーを意味します。
          </p>
          <p>
            「アフィリエイトパートナーサイト」とは、当サイト上のアフィリエイトリンクおよびコードを促す、アフィリエイトパートナーによって維持および運営されているプラットフォーム(例：ウェブサイト/アプリ/ウィジェットなど)
            を意味します。
          </p>
          <p>
            「アフィリエイトリンク」とは、アフィリエイトパートナーのウェブサイトから勝winへのハイパーリンクを意味します。
          </p>
          <p>
            「アフィリエイトコード」とは、アフィリエイトパートナーごとに設定されたコードを意味し、登録時に入力されたコードであったとしても、アフィリエイトパートナーのアフィリエイトメンバーとして設定されたコートを意味します。
          </p>
          <p>
            「プレイヤー」とは、当サイト上でゲームアカウントを作成し、ベットを行う人物を意味します。
          </p>
          <p>
            「アカウント」とは、当サイトでゲームをプレイする目的で作成されたアカウントを意味します。
          </p>
          <p>
            「アフィリエイトアカウント」とは、当サイトのアフィリエイトプログラムに登録する際に発行されるアカウントを意味します。
          </p>
          <p>
            「アクティブメンバー」とは、入金、およびベットを行ったアフィリエイトプレイヤーを意味します。
          </p>
          <p>
            「コミッション」とは、本利用規約および条件に従ってアフィリエイトパートナーに支払われる金額を意味します。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            1. アフィリエイトパートナー条件
          </h3>
          <p>1.1 アフィリエイトパートナーは、以下を表明および保証いたします：</p>
          <p>
            1.2
            アフィリエイトパートナー契約期間中、お客様はアフィリエイトパートナー契約を締結し、そこに含まれるすべての義務を履行する権利と権限を有します。
          </p>
          <p>
            1.3
            お客様は、アフィリエイトパートナー契約に基づく義務を履行するために必要なすべての登録、ライセンス、同意および許可を取得し、維持するものといたします。
          </p>
          <p>1.4 アフィリエイトパートナー契約は、条件を十分に理解し、同意したものとみなします。</p>
          <p>
            1.5
            当サイトは、提出されたアフィリエイトパートナー情報を審査し、アフィリエイトパートナー申請を承認するかどうかを電子メールでアフィリエイトパートナーに通知いたします。
            当サイトは独自の裁量により登録を拒否する権利を留保いたします。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            2. 当社の権利と義務
          </h3>
          <p>
            2.1
            当サイトは、コミッション合計の記録を保管し、アフィリエイトパートナーのアフィリエイトアカウントからコミッション合計と統計をパートナーに提供いたします。
          </p>
          <p>
            2.2
            当サイトは、これらの利用規約に従い、アフィリエイトパートナーにコミッションをお支払いいたします。
          </p>
          <p>
            2.3
            当サイトは、当サイトが適切と判断した時点で、いつでもアフィリエイトプログラムを終了、変更、または終了する権利、および当サイトの独自の裁量で本利用規約の規定を変更する権利を留保いたします。データの変更については、アフィリエイトパートナーに電子メール通知を送付いたします。
          </p>
          <p>
            2.4
            当サイトは、独自の裁量で新しいアフィリエイトパートナーを受け入れる権利を留保いたします。
          </p>
          <p>
            2.5
            当サイトは、以下の状況において最終決定を下し、アフィリエイトパートナーのアカウントを閉鎖する権利を留保いたします。
          </p>
          <p>2.6 当サイトが唯一認める国内および国際的な規制を遵守するために、</p>
          <p>2.7 当サイトのポリシーに従う必要がございます。</p>
          <p>
            2.8
            当サイト、アフィリエイトパートナー、アフィリエイトメンバー、またはその他の第三者組織の利益を保護いたします。
          </p>
          <p>
            2.9
            当サイトは、高レベルのセキュリティ、マネーロンダリング防止の法的要件の遵守、および本アフィリエイト関係の管理のため、当サイトのプライバシーポリシーに従い、アフィリエイトパートナーの個人データを使用および処理いたします。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            3. アフィリエイトアフィリエイトパートナーの権利と義務
          </h3>
          <p>3.1 アフィリエイトパートナーは以下を保証し、同意するものといたします。</p>
          <p>
            3.2
            当サイトとアフィリエイトパートナーに可能な限り最大の利益をもたらすために、自らの費用負担を行い、当サイトをマーケティングおよび宣伝すること。
          </p>
          <p>
            3.3
            アフィリエイトマーケティングプログラムの範囲内で提供されるアフィリエイトリンク、アフィリエイトコード、プロモーション、またはマーケティングツールを使用すること。
          </p>
          <p>
            3.4
            アフィリエイトパートナーのマーケティング活動は、適切かつ専門的で、本規約に従ったものでなければなりません。
          </p>
          <p>
            3.5
            関連法規および適用法を常に遵守すること。これには、データ保護およびプライバシーに関する適用法が含まれるが、これに限定されません。
          </p>
          <p>3.6 アフィリエイトパートナーサイトの維持および開発に責任を持つこと。</p>
          <p>3.7 アフィリエイトパートナーサイトの新情報を適時に更新すること。</p>
          <p>
            3.8
            当サイトのプレイヤーまたはアフィリエイトパートナーサイトにアクセスできる者(プレイヤーを含むがこれに限定されない)が、アフィリエイトパートナーサイト上で当サイトに不利益を与えるような誤解を招く発言を行ったことから生じる責任または事態について責任を負うこと。
          </p>
          <p>3.9 当サイトに有利な方法でビジネスを行うこと。</p>
          <p>
            3.10
            差別的、わいせつ、違法、ポルノ、エロティックまたは暴力的な内容を含むマーケティング活動(提携サイトを含む)を行わないこと。
          </p>
          <p>3.11 法定ギャンブル年齢に満たない人をターゲットにしないこと。</p>
          <p>
            3.12 ギャンブルおよびギャンブルのプロモーションが違法とされる地域を対象としないこと。
          </p>
          <p>
            3.13
            当サイト上のマーケティングツールを除き、当社の同意なしに、当社または当サイトの所有者・運営者のその他の表現、商標、知的財産権を使用しないこと。
          </p>
          <p>
            3.14
            アフィリエイトパートナーは、当社から提供されたログイン情報の機密性、安全性及び保護を常に維持するものとします。アフィリエイトパートナーがログイン情報を適切に保護しなかった結果、ログイン情報が不正に使用された場合、アフィリエイトパートナーは全責任を負うものとします。
          </p>
          <p>
            3.15
            アフィリエイトパートナーは、アフィリエイトパートナーのアカウントのユーザー名およびパスワードを使用したすべての活動および行為について全責任を負うものとします。アフィリエイトパートナーは、身分証明書の違法かつ不正な使用が疑われる場合、直ちに当サイトに通知するものとします。
          </p>
          <p>
            3.16
            当サイトは、アフィリエイトパートナーによる不正な登録、紹介、またはベットが行われた場合、または本規約に違反した場合、アフィリエイトパートナーのアカウントを凍結し、アフィリエイトパートナーのアカウントからコミッションを差し引く権利を有するものとします。
          </p>
          <p>
            3.17
            当サイトに新規メンバーを誘致するため、可能な限り積極的かつ効果的な方法で、当ウェブサイトを広く広告、マーケティング、宣伝するよう最善の努力を払うこと。
          </p>
          <p>
            3.18
            アフィリエイトパートナーは、自身のウェブサイトの所有権および責任について全責任を負うものといたします。
          </p>
          <p>
            3.19
            アフィリエイトの活動から生じる費用や問題は、アフィリエイトパートナーが単独で責任を負うものとし、当社は、それらすべての費用や問題に対して責任を負わないものとします。
          </p>
          <p>
            3.20
            すべてのアフィリエイトにおける行動は、本契約および適用される法令に従い、専門的で適正かつ合法的でなければなりません。
          </p>
          <p>3.21 アフィリエイトパートナーは以下の禁止行為をしてはなりません。</p>
          <p>3.22 法定年齢に満たない未成年者を公営ギャンブルに参加させる行為。</p>
          <p>3.23 登録サイト以外で当サイトの宣伝を行うこと。</p>
          <p>
            3.24
            アフィリエイトパートナーが自ら、または第三者と共謀して、報酬発生の条件となる行為があったかのように装う行為、その他宣伝目的や当サービス以外の目的で登録する行為等、不当な報酬を得ようとする行為とみなされる行為を行うこと。
          </p>
          <p>
            3.25
            当社は、上記の行為が発覚した場合、報酬を取り消し、アカウントを停止する権利を有するものとします。
          </p>
          <p>
            3.26
            当社への事前の通知及び承諾なく、第三者に代わってアフィリエイトプログラムに登録する行為、アフィリエイトアカウントを開設すること、またはアフィリエイトアカウントを第三者に譲渡すること。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            4. コミッションと支払い
          </h3>
          <p>
            4.1当社は、本規約に従い、アフィリエイトパートナーにコミッションを支払うものといたします。
          </p>
          <p>
            4.2
            コミッションは指定されたアフィリエイトパートナーのアカウントに支払われます。万が一コミッションの計算に誤りがあった場合、当社はいつでも計算を修正する権利を留保し、過払いを直ちに支払うか、コミッションの過払いを回収することができるものといたします。
          </p>
          <p>
            4.3当社がアフィリエイトパートナーに支払うべきとみなしたコミッションは毎月10日計算され、毎月15日の23:00までにアフィリエイトパートナーのアカウントに支払われます。一時的にシステム調整が行われた場合、コミッションの配付が遅れる場合がございます。コミッションは日本円で支払われます。
          </p>
          <p>
            4.4 コミッションの計算公式は以下の通りです: （勝負値（ベット額-ペイアウト）-
            ボーナス費用 - プラットフォーム費用 - ジャックポット - 手数料 ） × コミッション％
          </p>
          <p>4.5 最低支払額は2日本円(JYP)以上といたします。</p>
          <p>
            4.6
            コミッションの支払いは、マイナス繰越制度を使用して行われます。つまり、アフィリエイトメンバーのゲーム結果によりマイナス残高が生じた場合、そのマイナス残高は翌月に繰り越されます。コミッションの支払いは、前月の収益がプラス残高を示し、前月から繰り越されたマイナス残高を相殺したときに行われます。
          </p>
          <p>
            4.7
            チャージバック請求額がその月のアフィリエイトパートナーのコミッションを上回った場合、マイナスの繰越が記録されます。
          </p>
          <p>
            4.8
            3ヶ月連続でアクティブなアフィリエイトメンバーがいない場合、非アクティブとみなされ、ウォレット内のコミッションはすべてリセットといたします。
          </p>
          <p>
            4.9
            連続6ヶ月間アクティブなアフィリエイトメンバーがいない場合、アカウントは停止され、ウォレット内のコミッションはすべてリセットといたします。
          </p>
          <p>
            4.10 以下の場合はコミッションから差し引かれます。
            <br>「相互利益」の原則に基づき、以下の状況を含みますが、これらに限定されません。不正行為により一方の当事者が不平等な利益を得た場合、それらの状況における当サイトの判断が最終決定となります。
          </p>
          <p>
            4.11
            アフィリエイトパートナーは、不正または誤った取引の結果として獲得したコミッションを全額払い戻す必要がございます。
          </p>
          <p>
            4.12
            当サイトは、コミッションに関するいかなる権利についても最終決定を下す権利を有します。
          </p>
          <p>
            4.13
            当サイトのアフィリエイトプログラムにおけるコミッションは、レベニューシェア型契約に従って徴収されます。アフィリエイトパートナーが一度獲得したコミッションは、生涯有効でございます。
          </p>
          <p>
            4.14
            当アフィリエイトプログラムのコミッション率は、月ごとの新規入金アフィリエイトメンバーに応じて変動いたします。
          </p>
          <p>
            4.15
            万が一アフィリエイトメンバーから払い戻しが要求された場合、該当する金額がアフィリエイトパートナーのコミッションから差し引かれます。
          </p>
          <p>
            4.16
            コミッションは直接出金することが可能でございます。また、コミッションを利用しゲームをプレイしていただけます。
          </p>
          <p>
            4.17
            ただし、ゲームをプレイされた後にコミッションの出金申請を提出される場合は、KYC書類の提出をする必要がございます。
          </p>
          <p>
            4.18
            不正または虚偽の取引に基づいて受領したコミッションをすべて返却することに同意し、当該取引に関連して発生したすべての費用および損失(弁護士費用と経費を含むがこれに限定されない)を補償いただきます。
          </p>
          <p>
            4.19
            アフィリエイトパートナーは、本契約に基づく報酬の結果として、国内外を問わず、課税当局、部門、またはその他の団体に支払うべきすべての税金、徴収、手数料、支払う必要のあるその他の金銭に全責任を負うものといたします。当社は、未払い金額について責任を負わないものとし、アフィリエイトパートナーはこれに同意したものとみなされます。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            5. アフィリエイトサイト
          </h3>
          <p>
            5.1ドメイン名に当サイト名(勝win)または類似のドメインを使用することは禁止いたします。
          </p>
          <p>
            5.2アフィリエイトサイトにおいて、公式サイトとアフィリエイトサイトが混在するような不正と思われる行為は厳禁といたします。
          </p>
          <p>
            5.3当社のアフィリエイト部門は、ロゴ、バナー、リンクなどテキストコメント内の情報やグラフィック素材を必要に応じて更新いたします。アフィリエイトパートナーが情報の更新や変更を拒否した場合、その契約は停止され、情報が更新されるまで支払いは延期されることがございます。
          </p>
          <p>
            5.4当社は、アフィリエイトパートナーが本契約の条件を遵守していることを確認するため、アフィリエイトパートナーのウェブサイトなどを監視する権利を留保いたします。アフィリエイトパートナーは、監視を行うために合理的に必要なすべてのデータを当社に提供するものといたします。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            6. 禁止事項
          </h3>
          <p>
            6.1
            以下の禁止事項が発覚した場合、当サイトでは関連する全てのコミッションを没収とし、アカウントを凍結いたします。
          </p>
          <p>
            6.2
            アフィリエイトパートナーとアフィリエイトメンバーが同じIPもしくは同じアカウント名であること。
          </p>
          <p>
            6.3
            アフィリエイトパートナーが自身のアフィリエイトアカウントでゲームアカウントを登録している(自己アフィリエイト)こと。
          </p>
          <p>
            6.4
            アフィリエイトパートナーが、アフィリエイトパートナー自身のアフィリエイトリンクおよびコードを通じて、既存のプレイヤーにゲームアカウントの再登録を許可すること。
          </p>
          <p>
            6.5
            アフィリエイトパートナーが別のアフィリエイトパートナーのアフィリエイトメンバーになること。
          </p>
          <p>6.6 アフィリエイトパートナー同士が協力してコミッションを獲得すること。</p>
          <p>
            6.7
            アフィリエイトパートナーは、アフィリエイトメンバーまたはプレーヤーと協力してコミッションを不正に獲得すること。
          </p>
          <p>
            6.8
            自分自身または友人、従業員、その他の第三者をプレーヤーとして登録し、直接的または間接的に、自分自身の個人的な使用または第三者の使用のために、プレイヤーのアカウントに資金を入金すること、またはアフィリエイトアカウントの使用について当社および当サイトを欺く行為によって、コミッションを増やすこと。このような行為はすべて詐欺行為とみなします。
          </p>
          <p>
            6.9
            アフィリエイトアカウントにログインした後、バックグラウンドで確認できる情報を、意図の如何にかかわらず、友人、プレーヤー、従業員、または第三者に開示することは禁止いたします。アフィリエイトパートナーは、情報の漏洩によって生じた損失、傷害、損害についてすべての責任を負うものといたします。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            7. 契約の取り消しまたは終了
          </h3>
          <p>
            7.1
            アフィリエイト契約は、当社のアフィリエイト契約チームにEメールで通知することにより、本契約を終了することができます。また、当社が当サイトを通じてゲームサービスを提供できなくなった場合も、本契約は自動的に終了いたします。
          </p>
          <p>
            7.2
            次のいずれかに該当する場合、当社はアフィリエイトパートナーのアカウント登録を抹消し、通知または承諾なしにアフィリエイト契約を終了させることができます。
          </p>
          <p>7.3 アフィリエイトパートナーが本規約に重大な違反をしているとみなされた場合。</p>
          <p>7.4 アフィリエイトパートナーが違法行為を行っていると判断された場合。</p>
          <p>
            7.5
            アフィリエイトパートナーが1年間報酬を獲得しなかった場合、またはアフィリエイトパートナーが1年間アフィリエイトとしての活動を実質的に行っていないと当社が判断した場合。
          </p>
          <p>
            7.6 アフィリエイトパートナーは、本契約の終了時に以下の事項に同意するものといたします。
          </p>
          <p>
            7.7
            アフィリエイトパートナーは、マーケティング目的の有無にかかわらず、当社に帰属するすべての商標(バナー、ロゴなど)を削除する必要がございます。
          </p>
          <p>
            7.8
            アフィリエイトパートナーは、アフィリエイトパートナーが所有、保管、管理するすべての機密情報を含む資料の原本(およびそれらのコピーやそれらに派生するもの)を当社に返却するか、またはそれらの情報を含むデータを永久に削除する必要がございます。
          </p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            8. 機密事項
          </h3>
          <p>
            8.1
            すべての情報は秘密情報とみなされ、当社の書面による明示的な事前の同意なく、直接的、間接的を問わず、個人的、商業的、その他の目的で使用してはならないものといたします。
          </p>
          <p>
            8.2
            アフィリエイトパートナーは、本規約に基づく義務の履行以外の目的で機密情報を使用してはなりません。
          </p>
          <p>8.3 機密事項条項は、本契約の終了後も有効に存続するものといたします。</p>
          <!-- part End -->

          <h3 class="list-title mt-5">
            9. 管轄裁判所
          </h3>
          <p>
            本規約は、コモロ・アンジュアン連合自治島の法律に準拠し、これに従って解釈されるものといたします。本規約に関連する訴訟は、コモロ連邦自治島アンジュアンの仲裁当局に提出し、裁定を仰ぐものとします。
          </p>
          <!--  -->
          <h3 class="list-title mt-5">
            10. 利用規約と条件および本契約の変更
          </h3>
          <p>
            当社は、アフィリエイトパートナーに事前に通知することなく、いつでも本規約の条項を修正、変更、削除または追加する権利を留保いたします。これらの修正については、電子メールにてアフィリエイトパートナーに通知いたします。当社が修正または変更を発表した後、アフィリエイトプログラムへの参加を継続した場合、アフィリエイトパートナーは新しい規約に同意したものとみなします。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    affiliateEmail() {
      return process.env.VUE_APP_AFFILFATES_MAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
